import { useSnapshot } from "valtio"
import { ErrorActions, ErrorState } from "../../stores/errorStore"

export function useErrors() {
  return { ...ErrorActions, clearErrors: ErrorActions.clear }
}

export function useActionErrors() {
  const { actionError } = useSnapshot(ErrorState)
  return actionError
}

export function useCardError() {
  const { cardError } = useSnapshot(ErrorState)
  return cardError
}

export function useReceiptErrors() {
  const { receiptErrors } = useSnapshot(ErrorState)
  return receiptErrors
}

export function useWalletError() {
  const { walletError } = useSnapshot(ErrorState)
  return walletError
}

export function useInsufficientFundsActionError() {
  const { insufficientFundsActionError } = useSnapshot(ErrorState)
  return insufficientFundsActionError
}
